"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var owa_feature_flags_1 = require("owa-feature-flags");
var FeatureFlagsListItem_1 = require("./FeatureFlagsListItem");
var FeatureFlagsList = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsList, _super);
    function FeatureFlagsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsList.prototype.render = function () {
        return (React.createElement("div", null, owa_feature_flags_1.featureFlags
            .keys()
            .sort()
            .map(function (key) { return (React.createElement(FeatureFlagsListItem_1.default, { name: key, key: key, isOn: owa_feature_flags_1.featureFlags.get(key) })); })));
    };
    FeatureFlagsList = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsList);
    return FeatureFlagsList;
}(React.Component));
exports.default = FeatureFlagsList;
//# sourceMappingURL=FeatureFlagsList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/FeatureFlags/FeatureFlagsList.js
// module id = 6202
// module chunks = 38